import {Component, OnInit, OnDestroy} from '@angular/core';
import { Router, ActivatedRoute,NavigationEnd} from '@angular/router';
import { Authorization } from '../authorization/index';
import {NavigationService} from "../common/NavigationEventService";
import {ToolbarService} from "../common/ToolbarEventService";
import {ToolbarEvent} from "../common/ToolbarEvent";
import {ToolbarEventPageEnum} from "../common/ToolbarEvent";
import { Subscription } from 'rxjs';
import {TranslateService} from "@ngx-translate/core";
import {Config} from "../../../environments/environment";

declare var $: any;

/**
 * This class represents the toolbar component.
 */

@Component({
    selector: 'sd-toolbar',
    providers: [],
    templateUrl: 'toolbar.component.html',
    styleUrls: ['toolbar.component.css'],
    standalone: false
})


export class ToolbarComponent implements OnInit, OnDestroy{
  navigationContent: string = "none";
  private subscription:Subscription;
  private routerEventSubscription: any;
  private routerParamSubscription: any;
  showToolbar: boolean = false;
  currentState:ToolbarEvent=new ToolbarEvent(ToolbarEventPageEnum.NONE, "", null, "", "-","-", "", "", "false");
  showUserDropDown:boolean=false;
  showAboutModal:boolean = false;
  logo:string;

  constructor( private router: Router,
               private route: ActivatedRoute,
               private authorization: Authorization,
               private toolbarService: ToolbarService,
               private translate: TranslateService,
               private navigationService: NavigationService){

    this.navigationService.value = "3";
  }

  ngOnInit() {
    this.subscription=this.toolbarService.eventOccured$.subscribe(
      (event:ToolbarEvent) => this.onToolbarEvent(event)
    );

    this.logo = Config.LOGO;
  }


  private onToolbarEvent(event: ToolbarEvent) {
    switch (event.page) {
      case ToolbarEventPageEnum.JOBS:
        this.currentState = event;
        this.currentState.title = "";//this.translate.instant("Documents View"); //LANGUAGE Modifications
        this.showToolbar = true;
        break;
      case ToolbarEventPageEnum.JOB_DETAILS:
        this.currentState = event;
        this.showToolbar = true;
        break;
      case ToolbarEventPageEnum.JOB_SIGN_REQUEST:
        this.currentState = event;
        this.showToolbar = true;
        break;
      case ToolbarEventPageEnum.JOB_SELF_SIGNING:
        this.currentState = event;
        this.showToolbar = true;
        break;
      case ToolbarEventPageEnum.ACCOUNT:
        this.currentState = event;
        this.showToolbar = true;
        this.currentState.title = this.translate.instant("My Account");
        break;
      case ToolbarEventPageEnum.UPGRADE:
        this.currentState = event;
        this.showToolbar = true;
        this.currentState.title = this.translate.instant("Upgrade Plan"); //LANGUAGE Modifications
        break;
      case ToolbarEventPageEnum.SUBSCRIPTION:
        this.currentState = event;
        this.showToolbar = true;
        this.currentState.title = this.translate.instant("Subscription Info"); //LANGUAGE Modifications
        break;
      case ToolbarEventPageEnum.PAYMENT_RESULT:
        this.currentState = event;
        this.showToolbar = true;
        this.currentState.title = this.translate.instant("Result"); //LANGUAGE Modifications
        break;
      case ToolbarEventPageEnum.COMBINE:
        this.currentState = event;
        this.showToolbar = true;
        //this.currentState.title = this.translate.instant("Upload and Combine Documents"); //LANGUAGE Modifications
        break;
      case ToolbarEventPageEnum.VIEW:
        this.currentState = event;
        this.showToolbar = true;
        //this.currentState.title = this.translate.instant("Upload and Combine Documents"); //LANGUAGE Modifications
        break;
      case ToolbarEventPageEnum.VALIDATE:
        this.currentState = event;
        this.showToolbar = true;
        this.currentState.title = this.translate.instant("Documents Verification"); //LANGUAGE Modifications
        break;
      case ToolbarEventPageEnum.PREPARE:
        this.currentState = event;
        this.showToolbar = true;
        this.currentState.title = this.translate.instant("Document Preparation"); //LANGUAGE Modifications
        break;
      case ToolbarEventPageEnum.PREPARE_SELF:
        this.currentState = event;
        this.showToolbar = true;
        this.currentState.title = this.translate.instant("Document Preparation"); //LANGUAGE Modifications
        break;
      case ToolbarEventPageEnum.DOC_REQUEST:
        this.currentState = event;
        this.showToolbar = false;
        this.currentState.title = this.translate.instant("Document Request"); //LANGUAGE Modifications
        break;
      case ToolbarEventPageEnum.JOB_MULTISIGN_REQUEST:
        this.currentState = event;
        this.showToolbar = true;
        this.currentState.title = this.translate.instant("Multiple Document Signing"); //LANGUAGE Modifications
        break;
      case ToolbarEventPageEnum.HOME:
        this.currentState = event;
        this.showToolbar = false;
        //this.currentState.title = "Documents View"; //LANGUAGE Modifications
      default:
        if(event.page != undefined) {
          this.currentState = event;
          this.showToolbar = true;
        }
        break;
    }
  }

  showAbout(){
    this.showAboutModal = true;
  }

  public navigateToHome(){
    location.href="/";
  }

  public navigateToAccountSettings(){
    this.router.navigate(["/account"]);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.routerEventSubscription.unsubscribe();
  }
}

